module.exports = __webpack_public_path__ + "static/media/hero-screenshot-2.2ef9f95e.png";